import { render } from "./CreateCategoryModal.vue?vue&type=template&id=79700438&scoped=true&ts=true"
import script from "./CreateCategoryModal.vue?vue&type=script&lang=ts"
export * from "./CreateCategoryModal.vue?vue&type=script&lang=ts"

import "./CreateCategoryModal.vue?vue&type=style&index=0&id=79700438&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79700438"]])

export default __exports__